import { oc } from '@orpc/contract';
import { templateDetailSchema, updateTemplateInputSchema } from '../schemas/templates.schemas.js';
/** PATCH semantics over the identity fields only; the values live on the versions. */
export const updateTemplateContract = oc
    .route({
    method: 'POST',
    path: '/templates/{templateId}',
    tags: ['Templates'],
    summary: 'Update the template identity',
})
    .input(updateTemplateInputSchema)
    .output(templateDetailSchema);
//# sourceMappingURL=update-template.contract.js.map